/* eslint-disable no-console */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import {
  injectBDDTokensAndReturnUserDetails,
  BDDTokenResponse,
} from '../../../auth/bddTokenUtils';
import { setLoginSuccess } from '../../../reducers/userSessionSlice';
import { getVectorConfiguration } from '../../../reducers/vectorConfigurationSlice';
// import { checkFeatureFlag } from '../../../reducers/featureFlagSlice';
// import { featureFlags } from '../App';

const useBddManualLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isBdd = urlParams.get('isBdd') === 'true';
    if (!isBdd) return;

    const bddManualLoginHandler = async (event: any) => {
      const response = event.detail;
      if (!response) return;

      try {
        // Inject tokens into Auth0 SDK's internal storage
        const { username, accessToken } = injectBDDTokensAndReturnUserDetails(
          response as BDDTokenResponse,
        );
        console.log('currentUser', username);
        dispatch(
          setLoginSuccess({
            username,
            accessToken,
            refreshToken: '',
            userRoles: [],
          }),
        );
        dispatch(getVectorConfiguration());
        // dispatch(
        //   checkFeatureFlag({
        //     flagNames: featureFlags,
        //     currentUser: username || '',
        //   }),
        // );
        console.log('BDD login completed successfully');
      } catch (error) {
        console.error('Error during BDD login:', error);
      }
    };

    document.addEventListener(
      'bddManualLogin',
      bddManualLoginHandler as EventListener,
    );

    return () => {
      document.removeEventListener(
        'bddManualLogin',
        bddManualLoginHandler as EventListener,
      );
    };
  }, [dispatch, navigate, getAccessTokenSilently]);
};

export default useBddManualLogin;
